// @ts-strict-ignore
import React from 'react';
import { Box, Text } from '@usealloy/component-library';
import { Tab, TabCount } from './styles';
import { snakeToCaps } from '~/helpers/formatting';

interface MetadataTabsProps {
  currentTab: string;
  setCurrentTab: (string) => void;
  tabCounts: { [tab: string]: number };
  tabs: string[];
}

const MetadataTabs = ({
  currentTab,
  setCurrentTab,
  tabCounts,
  tabs,
}: MetadataTabsProps) => (
  <Box
    alignItems="flex-start"
    direction="column"
    gap={3}
  >
    {tabs.map(label => (
      <Tab
        alignItems="center"
        justifyContent="space-between"
        key={`evaluation-metadata-modal-tab-${label}`}
        onClick={() => { setCurrentTab(label); }}
        onKeyDown={({ keyCode }) => { if (keyCode === 13) { setCurrentTab(label); } }} // on enter
        isSelected={currentTab === label}
        tabIndex={0}
      >
        <Text>{snakeToCaps(label)}</Text>
        {!!tabCounts?.[label] && (
          <TabCount data-testid={`${label}-tab-count`}>{tabCounts[label] > 999 ? '999+' : String(tabCounts[label])}</TabCount>
        )}
      </Tab>
    ))}
  </Box>
);

export default MetadataTabs;
